module.exports = __webpack_public_path__ + "static/media/print-header-background.f48797ae.webp";